// extracted by mini-css-extract-plugin
export default {"singleLevel":"ColumnTree_singleLevel__TmNnJ"};